import { Injectable } from '@angular/core'
import { CanActivate, CanActivateChild } from '@angular/router'
import { SessionService } from 'src/services/session-service'

@Injectable({providedIn: 'root'})
export class UserCustomerGuard implements CanActivate, CanActivateChild {
  constructor(private sessionService: SessionService) {}

  canActivate(): Promise<boolean> {
    return new Promise((resolve) => {
      this.checkRole().then(role => {
        if (role === 'customer' || role === 'white_label' ) {
          resolve(true)
        } else {
          if (window) window.location.pathname = '/'
          resolve(false)
        }
      })
    })
  }

  canActivateChild(): Promise<boolean> {
    return this.canActivate()
  }

  checkRole(): Promise<boolean | string> {
    return this.sessionService.currentRole()
  }

}
